import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { MailForm } from '@/repositories/generated';
import { ErrorBody } from '@/types';

export const sendPasswordResetMail = http.post(
  createMockEndpoint('/login/password/reset/send_mail'),
  async ({ request }) => {
    const requestBody = await request.json() as MailForm;
    await delay(500);

    const createResponse = (): ErrorBody | object => {
      if (requestBody.loginId.includes('error')) {
        return {
          error: {
            code: 'MOCK_API_ERROR',
            message: 'モック用エラー。モック用エラー。モック用エラー。モック用エラー。モック用エラー。モック用エラー。',
          },
        };
      }
      return {};
    };

    const response = createResponse();
    const statusCode = 'error' in response ? 400 : 200;

    return HttpResponse.json(response, { status: statusCode });
  },
);
